var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:[
		'selector',
		{
			'selector--v3': _vm.isV3,
		},
	]},[(_vm.title)?_c('p',{staticClass:"selector__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('select',{staticClass:"selector__select",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.change,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')}}},_vm._l((_vm.optionList),function(item){return _c('option',{key:item[_vm.valueKey],domProps:{"value":item[_vm.valueKey],"selected":item[_vm.valueKey] === _vm.value}},[_vm._v(" "+_vm._s(item[_vm.nameKey])+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }